"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const roomViewStore_1 = require("@/room/room_view/roomViewStore");
const react_countdown_1 = __importDefault(require("react-countdown"));
const detect_utils_1 = require("@/common/detect_utils");
const material_ui_confirm_1 = require("material-ui-confirm");
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const _1 = require(".");
function default_1({ expand }) {
    const startDateUnixTimestamp = (0, react_redux_1.useSelector)((state) => state.roomData.startDateUnixTimestamp);
    const endDateUnixTimestamp = (0, react_redux_1.useSelector)((state) => state.roomData.endDateUnixTimestamp);
    const serverTime = (0, react_redux_1.useSelector)((state) => state.roomData.server_time);
    const dispatch = (0, react_redux_1.useDispatch)();
    const closeSales = () => {
        dispatch((0, roomViewStore_1.setSalesClosed)(true));
    };
    const refreshServerTime = () => {
        dispatch((0, roomViewStore_1.getServerTime)());
    };
    const startDeltaRemaining = (0, react_1.useRef)(0);
    const [countdownMounted, setCountdownMounted] = (0, react_1.useState)(false);
    const DELTA_DIFF_LIMIT = 100; // ms
    const startTime = (0, _1.useOrderTimer)({
        startDateUnixTimestamp,
        endDateUnixTimestamp,
        serverTime,
        closeSales,
        refreshServerTime,
        startDeltaRemaining,
        countdownMounted,
        DELTA_DIFF_LIMIT,
    });
    const onCountdownMount = () => {
        setCountdownMounted(true);
        refreshServerTime();
    };
    const visible = (0, detect_utils_1.useVisibilityChange)();
    const onTick = (delta) => {
        if (startDeltaRemaining.current === 0)
            return;
        const deltaDiff = startDeltaRemaining.current - delta.total;
        if (visible && Math.abs(deltaDiff) > DELTA_DIFF_LIMIT) {
            refreshServerTime();
        }
        startDeltaRemaining.current = delta.total;
    };
    const roomId = (0, react_redux_1.useSelector)((state) => state.roomData.id);
    const cart = (0, react_redux_1.useSelector)((state) => state.cart);
    const isDemandSurvey = (0, react_redux_1.useSelector)((state) => state.isDemandSurvey);
    const customDeliveryId = (0, react_redux_1.useSelector)((state) => state.customDeliveryId);
    const refetchProductData = () => {
        dispatch((0, roomViewStore_1.getProductDataForSale)(roomId));
    };
    const confirm = (0, material_ui_confirm_1.useConfirm)();
    const { orderPending, submitOrder } = (0, _1.submitCartOrder)({
        roomId,
        cart,
        isDemandSurvey,
        customDeliveryId,
        refetchProductData,
        confirm,
    });
    const whoAmI = (0, react_redux_1.useSelector)((state) => state.whoAmI);
    const paymentApprovalCd = (0, react_redux_1.useSelector)((state) => state.roomData.payment_approval_cd);
    const submitDemand = () => __awaiter(this, void 0, void 0, function* () {
        const isDemandSubmittable = (0, _1.blockDemandSurveyOrderConfirm)({
            confirm,
            whoAmI,
            paymentApprovalCd,
        });
        if (isDemandSubmittable) {
            yield submitOrder();
        }
    });
    const submitFn = isDemandSurvey ? submitDemand : submitOrder;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ container: true, justifyContent: "space-between", position: "relative" }, { children: (0, jsx_runtime_1.jsx)(react_countdown_1.default, { date: startTime, intervalDelay: 0, onTick: onTick, precision: 3, renderer: countdownRenderProps => ((0, jsx_runtime_1.jsx)(_1.CountdownButtonRenderer, { expand: expand, orderPending: orderPending, submitFn: submitFn, countdownRenderProps: countdownRenderProps })), onMount: () => !countdownMounted && onCountdownMount(), onComplete: () => {
                        if (Math.abs(startDeltaRemaining.current) > DELTA_DIFF_LIMIT)
                            refreshServerTime();
                    } }, startTime) })), (0, jsx_runtime_1.jsx)(_1.OrderPendingModal, { orderPending: orderPending })] }));
}
exports.default = default_1;
